import { useState } from 'react';

import { Button } from '../../../../primitives/button';
import { Input } from '../../../../primitives/input';
import { Label } from '../../../../primitives/label';
import { getSplitName } from '../utils/get-split-name';

interface FormNameProps {
  name: string;
  onSubmit: (params: { name: string }) => void;
}

export function FormName({ name, onSubmit }: FormNameProps) {
  const { fileName, fileExtension } = getSplitName(name);
  const [inputValue, setInputValue] = useState(fileName);

  return (
    <form>
      <Label htmlFor={fileName}>Nombre</Label>
      <div className="flex">
        <Input
          autoComplete="off"
          autoFocus
          className="rounded-r-none border-r-0 pr-2 shadow-none focus-visible:ring-0"
          id={fileName}
          name="name"
          onChange={(event) => {
            setInputValue(event.target.value);
          }}
          value={inputValue}
        />
        <div className="flex items-center justify-center rounded-r-lg border border-l-0 border-input bg-accent pr-4 pl-2 text-sm">
          {fileExtension}
        </div>
      </div>
      <Button
        className="mt-2 w-full"
        onClick={() => {
          onSubmit({
            name: `${inputValue.replace(/\s/g, '_')}${fileExtension}`,
          });
        }}
      >
        Confirmar nombre
      </Button>
    </form>
  );
}
